export class AssignDeliveryModel {
    listGoodsId: number;
    shipmentContractNumber:string;
    shipmentNumberS:string;
    totalItem:number;
    shipmentStatusIds:any[]=[];
    shipmentBoxIds:any[]=[];
    shipmentStatusId:number;
    isLo:boolean;
    deliveryTruckId:number;
    index:number;
}